<template lang="pug">
  text-counter(name="person[memo]", :maxlength="maxlengths.memo", v-model="data", placeholder="趣味・嗜好・特技などを入力してください。", @input="$emit('input', data)", data-testid="edit-person-memo")
</template>

<script>
import TextCounter from '@/components/molecules/TextCounter'
export default {
  name: 'MemoForm',
  components: { TextCounter },
  props: {
    value: { type: String, required: true }
  },
  data () {
    return {
      data: '',
      maxlengths: {}
    }
  },
  watch: {
    value (newval, oldval) {
      if (newval !== oldval) {
        this.syncData(newval)
      }
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('Persons')
    this.syncData(this.value)
  },
  methods: {
    syncData (data) {
      this.data = data
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/forms/MemoForm.vue